import { LoadableAfterPaint } from '@confluence/loadable';

export const ContributorsMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContributorsMacro" */ '../src/ContributorsMacroRenderer.tsx'
			)
		).ContributorsMacroRenderer,
});
